import { render, staticRenderFns } from "./TestPackageDetail.vue?vue&type=template&id=58b26e82"
import script from "./TestPackageDetail.vue?vue&type=script&lang=js"
export * from "./TestPackageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports